export default {"src":"/_next/static/media/bidHistoryBackIcon.ecd79e7e.svg","height":21,"width":12};